export const downloadCSV = <T extends object>(
  identifier: string | number,
  data: T[],
  headers: string[],
  fields: (keyof T)[]
): void => {
  const csvRows = data.map((row) =>
    fields
      .map((field) => {
        const value = row[field]
        if (typeof value === 'string') {
          // Escape double quotes inside string values
          return `"${value.replace(/"/g, '""')}"`
        }
        return value
      })
      .join(',')
  )

  const csvContent =
    'data:text/csv;charset=utf-8,' +
    [headers.join(','), ...csvRows].join('\n')

  const encodedUri = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)

  const currentTime = new Date()
    .toLocaleTimeString('en-US', { hour12: false })
    .replace(/:/g, '')
  link.setAttribute(
    'download',
    `${identifier}-${currentTime}-data.csv`
  )

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
